import toast from "react-hot-toast";
import { setUser } from "../store/userSlice";
import { moneyFormatter } from "./utils";

import { decryptData } from "../validations/decryption";
import { getApi, postApi } from "../api/API";
import { User } from "../types";

export function generateUniqueId() {
  const prefix = "admin";
  const length = 26;
  const dashPositions = [5, 11, 17, 23];
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let id = prefix;
  for (let i = prefix.length; i < length; i++) {
    id += characters.charAt(Math.floor(Math.random() * characters.length));
    if (dashPositions.includes(i)) {
      id += "-";
    }
  }

  return id;
}

export const updateUserUUID = async () => {
  try {
    await postApi<any>({
      url: "https://api.sharepal.in/api:m1RX-Wnu/updateUserUid",
      body: {
        user_uid: localStorage.getItem("uid"),
      },
      type: "new_admin",
    });
  } catch (err) {
    console.error(err);
  }
};

export const getUser = async (dispatch: any) => {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }
  try {
    const data = await getApi<string>({
      url: "/auth/me/new",
      type: "new_admin",
      params: {},
    });

    const decryptedUser = await decryptData(data);

    // console.log("Decrypted User", decryptedUser);

    const user = JSON.parse(decryptedUser);

    dispatch(setUser(user));
    toast.success(`Welcome ${user.first_name}!`);
    return user;
  } catch (error: any) {
    console.log(error);
    toast.error(error.response.data?.message || `Something Went Wrong!`);
    return null;
  }
};

export const calculateRent = (
  totalDays: number,
  baseRent?: number,
  pdRent?: any,
  ptRent?: any,
  nFactor?: any,
  discount: number = 0,
  surgeFactor: number = 1,
): string | undefined => {
  if (!totalDays) {
    return;
  }

  if (baseRent || baseRent === 0) {
    if (pdRent === 0) {
      return ((ptRent - (ptRent * discount) / 100) * surgeFactor)?.toFixed(); // Apply discount to ptRent
    } else {
      const num_days = totalDays;
      const finalRent =
        baseRent +
        pdRent * Math.min(num_days, 15) +
        ptRent +
        Math.max(num_days - 15, 0) * nFactor;
      const discountedRent = finalRent - (finalRent * discount) / 100; // Apply discount to finalRent
      return (discountedRent * surgeFactor)?.toFixed();
    }
  } else {
    return "";
  }
};

export const calculateProductRent = (
  product: any,
  surgeFactor: number = 1,
): string | undefined => {
  if (!product?.num_days) {
    return;
  }
  const num_days = product?.num_days;
  const finalRent =
    product?.base_rent +
    product?.per_day_rent * Math.min(num_days, 15) +
    product?.rent_per_trip +
    Math.max(num_days - 15, 0) * product?.normalisation_factor;
  const total = parseFloat((finalRent * surgeFactor)?.toFixed());

  return moneyFormatter(total);
};

export const totalProductRent = (fullCart: any): string | undefined => {
  console.log(fullCart);
  if (!fullCart || fullCart?.length === 0) {
    console.log("return");
    return;
  }
  const total = fullCart?.reduce((accumulator: number, product: any) => {
    return Math.round(accumulator + product?.rent * product?.quantity);
  }, 0);

  return moneyFormatter(total);
};

export const totalDeposit = (fullCart: any): string => {
  if (!fullCart || fullCart?.length === 0) {
    return "No";
  }
  const total = fullCart?.reduce((accumulator: number, product: any) => {
    return Math.round(accumulator + product?.deposit * product?.quantity);
  }, 0);
  return moneyFormatter(total);
};

export const formatAddress = (address: any): string | undefined => {
  console.log("Format Address", address);
  if (!address) return;
  return `${address?.area_details || ""}, ${address?.road || ""}, ${
    address?.landmark || ""
  }, ${address?.city || ""}, ${address?.state || ""}, ${
    address?.pincode || ""
  }`;
};

export const getNumberOfDays = (startDate, endDate) => {
  startDate = new Date(startDate);
  endDate = new Date(endDate);
  // To calculate the time difference of two dates
  var Difference_In_Time = endDate - startDate - 1;
  // To calculate the no. of days between two dates
  var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  // console.log(Difference_In_Days);

  return parseInt(Difference_In_Days.toString());
};
